import { MessageListingDesktop } from "./messageListingDesktop";
import { MessageListingMobile } from "./messageListingMobile";
import * as React from "react";
import { Breakpoint } from "../../../";

export const MessageListing = () => (
    <>
        <Breakpoint desktop>
            <MessageListingDesktop />
        </Breakpoint>
        <Breakpoint mobile>
            <MessageListingMobile />
        </Breakpoint>
    </>
);
